// extracted by mini-css-extract-plugin
module.exports = {"root":"_7ad4cb","row":"_01f094","featureName":"_4138a5","alignRight":"_d3235d","alignLeft":"_e9c0bf"};